import { render, staticRenderFns } from "./buyers.vue?vue&type=template&id=facfdd64&"
import script from "./buyers.vue?vue&type=script&lang=js&"
export * from "./buyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports